import Component from "vue-class-component";

/**
 * Register the vue-router in-component guards with vue-class-component.
 *
 * vue-class-component only forwards the lifecycle hooks it knows about, and the
 * router guards are not in that list — a beforeRouteLeave()/beforeRouteUpdate()
 * method on a class component is silently ignored without this.
 *
 * THIS MUST BE ITS OWN MODULE, imported before any component is defined.
 * registerHooks only affects classes decorated AFTER it runs, and `import` is
 * hoisted: when this call lived at the top of main.ts's body, main.ts's own
 * imports (App.vue → router → EditView) had already evaluated and decorated every
 * class by the time it executed, so both hooks were dropped on the floor. The
 * symptom was quiet and easy to misread — no error, just guards that never fire:
 * unsaved edits abandoned without a prompt, and an edit → edit jump that changed
 * the URL while leaving the previous fabric on screen.
 *
 * Which is why the import in main.ts comes first, and must stay there.
 */
Component.registerHooks(["beforeRouteLeave", "beforeRouteUpdate"]);
